import * as Flow from 'ixfx/flow.js';

export type ModulationTimerFactory = () => Flow.ModulationTimer

export const timerFactory = (kind: `elapsed`, total: number, opts: Partial<{ clampValue: boolean, wrapValue: boolean }> = {}): ModulationTimerFactory => {

  switch (kind) {
    case `elapsed`:
      return () => Flow.relative(total, {
        ...opts,
        timer: Flow.elapsedMillisecondsAbsolute()
      })
    default:
      throw new Error(`Unknown kind: '${ kind }'`);
  }
}